import { BASE_URL } from "config";
import * as base from "./_base";

export const endpoints = {
  list: `${BASE_URL}/api/v1/site/`,
  detail: (id) => `${BASE_URL}/api/v1/site/${id}/`,
};

export const siteListLoad = (token, payload) => base.ListLoad(endpoints.list, token, payload);
export const siteDetailLoad = (token, { id }) => base.DetailLoad(endpoints.detail, token, { id });
export const siteUpdate = (token, data) => base.Update(endpoints.list, endpoints.detail, token, data);
export const siteDelete = (token, data) => base.Delete(endpoints.detail, token, data);
